import {DotPath} from '../getOrElse'
import {getDefinedOrElse} from './getter'
import {Decorators} from '../config/getterConfig'
import {decorate} from './decorator'

export function numberOr<R extends any, T extends number>(
  root: R,
  path: DotPath = '',
  decorators: Decorators<T> = [],
  orElse = 0 as T
): T {
  /*
   * Slight gotchas:
   * 1) Invoking a new number with the 'new Number' constructor causes
   *    TS issues.
   * 2) If the condtitional statement is used in the constructor a
   *    field with a non-numeric value will appear truthy resulting in
   *    a NaN numeric type.
   */
  return (Number(
     decorate(
       getDefinedOrElse(root, path, orElse),
       decorators
     )) || 0) as T
}